import { CinemarkLink } from '@/components/cinemark-link/cinemark-link';
import { useDataAnalytics } from '@/hooks/analytics/analytics';
import { dataTestTransformer } from '@/utils/data-test-helper';
import clsx from 'clsx';
import React from 'react';
import memberRewardsStyles from './member-rewards.module.scss';

type MemberRewardsProps = {
  text: string;
  textClassName?: string;
  useAnchor?: boolean;
  value: number;
  valueClassName?: string;
} & (
  | {
    dataLinkCategory: string;
    dataLinkName: string;
    link: string;
  }
  | {
    dataLinkCategory?: never;
    dataLinkName?: never;
    link?: never;
  }
);

export const MemberRewards = ({
  dataLinkCategory,
  dataLinkName,
  link,
  text,
  textClassName,
  useAnchor,
  value,
  valueClassName,
}: MemberRewardsProps): React.JSX.Element => {
  const { trackClick } = useDataAnalytics();
  const content =
    <>
      <p className={clsx('font-bold text-base', valueClassName)}
        data-test="member-rewards-value"
      >
        {value}
      </p>
      <p className={clsx('text-xs', textClassName)}
        data-test={`member-rewards-text-${dataTestTransformer(text)}`}
      >
        {text}
      </p>
    </>
  ;

  if (link) {
    return (
      <CinemarkLink className={memberRewardsStyles['reward-link']}
        dataLinkCategory={dataLinkCategory}
        dataLinkName={dataLinkName}
        dataTest={`link-member-rewards-${dataTestTransformer(text)}`}
        href={link}
        useAnchor={useAnchor}
        onClick={() => trackClick({
          linkCategory: dataLinkCategory,
          linkName: dataLinkName,
        })}
      >
        {content}
      </CinemarkLink>
    );
  }

  return (
    <div className={memberRewardsStyles['reward-link']}>
      {content}
    </div>
  );
};
